export default "__VITE_ASSET__q0brxoj2__"